/**
 * My Silhouette — standard size + inseam recommendation
 *
 * Recommendation chart/config is isolated in CELESTINES_SIZE_RECO so
 * thresholds can be replaced after physical fit validation without
 * rewriting the UI. Do not change these values casually.
 */
(function () {
  'use strict';

  // --- Isolated recommendation config (provisional; replace after fit validation) ---
  var CELESTINES_SIZE_RECO = {
    SIZE_CHART: [
      { size: 'UK 8',  waist: 66, hip: 92 },
      { size: 'UK 10', waist: 71, hip: 97 },
      { size: 'UK 12', waist: 76, hip: 102 },
      { size: 'UK 14', waist: 81, hip: 107 },
      { size: 'UK 16', waist: 87, hip: 113 },
      { size: 'UK 18', waist: 93, hip: 119 }
    ],
    INSEAMS: [
      { label: '34"', cm: 86.4 },
      { label: '36"', cm: 91.4 },
      { label: '38"', cm: 96.5 }
    ],
    SIZE_TOLERANCE_CM: 2.5,
    INSEAM_TOLERANCE_CM: 1.5
  };
  window.CELESTINES_SIZE_RECO = CELESTINES_SIZE_RECO;

  document.addEventListener('DOMContentLoaded', function () {
    var SAVE_URL = 'https://fit-profile-service.vercel.app/api/fit/save';
    var LS_KEY = 'fit_profile_data';

    var wrap = document.getElementById('fp-form');
    if (!wrap) return;

    var chart = CELESTINES_SIZE_RECO.SIZE_CHART;
    var inseams = CELESTINES_SIZE_RECO.INSEAMS;
    var sizeTol = CELESTINES_SIZE_RECO.SIZE_TOLERANCE_CM;
    var inseamTol = CELESTINES_SIZE_RECO.INSEAM_TOLERANCE_CM;

    var numericFields = ['waist', 'hip', 'inseam'];
    var required = ['waist', 'hip', 'inseam'];

    var els = {};
    numericFields.forEach(function (k) {
      els[k] = document.getElementById(k);
    });

    var saveBtn = document.getElementById('fp-save');
    var status = document.getElementById('fp-status');
    var unitBtns = document.querySelectorAll('.ys-unit-btn');
    var unitLabels = document.querySelectorAll('.ys-unit');
    var unit = 'cm';

    var toNum = function (v) {
      return v === '' ? '' : Math.max(0, Math.round(parseFloat(v) * 10) / 10);
    };

    function applyPrefill(src) {
      if (!src) return;
      numericFields.forEach(function (k) {
        if (src[k] !== undefined && src[k] !== null && src[k] !== '' && els[k]) {
          els[k].value = src[k];
        }
      });
    }

    if (window.__customerFitProfile) {
      applyPrefill(window.__customerFitProfile);
    } else {
      try {
        var saved = JSON.parse(localStorage.getItem(LS_KEY));
        if (saved) {
          applyPrefill(saved);
          if (saved.unit_system && saved.unit_system !== 'cm') {
            unit = saved.unit_system;
            unitBtns.forEach(function (b) {
              b.classList.toggle('active', b.getAttribute('data-unit') === unit);
            });
            unitLabels.forEach(function (el) {
              el.textContent = unit === 'in' ? 'in' : 'cm';
            });
          }
        }
      } catch (_) {}
    }

    function toCm(v) {
      var n = parseFloat(v);
      if (isNaN(n) || n <= 0) return null;
      return unit === 'in' ? n * 2.54 : n;
    }

    function sizeIndexFor(value, key) {
      for (var i = 0; i < chart.length; i++) {
        if (value <= chart[i][key] + sizeTol) return i;
      }
      return null;
    }

    function isMateriallyBelow(value, key) {
      return value < chart[0][key] - sizeTol;
    }

    function refreshSaveState() {
      var ok = required.every(function (k) {
        return els[k] && els[k].value !== '';
      });
      if (ok) {
        saveBtn.classList.add('enabled');
        saveBtn.disabled = false;
        if (status && !status.dataset.locked) {
          status.textContent = 'Ready to save';
        }
      } else {
        saveBtn.classList.remove('enabled');
        saveBtn.disabled = true;
        if (status && !status.dataset.locked) {
          status.textContent = 'Enter waist, hips and inseam to see your recommendation.';
        }
      }
      updateReco();
    }

    function recommendInseam(inseamCm) {
      var min = inseams[0].cm - inseamTol;
      var max = inseams[inseams.length - 1].cm + inseamTol;
      if (inseamCm < min || inseamCm > max) {
        return null;
      }
      var best = inseams[0];
      for (var j = 0; j < inseams.length; j++) {
        if (inseamCm <= inseams[j].cm + inseamTol) {
          best = inseams[j];
          break;
        }
        best = inseams[j];
      }
      return best;
    }

    function updateReco() {
      var box = document.getElementById('ys-reco');
      if (!box) return;

      var waist = toCm(els.waist && els.waist.value);
      var hip = toCm(els.hip && els.hip.value);
      var inseam = toCm(els.inseam && els.inseam.value);

      if (!waist || !hip || !inseam) {
        box.hidden = true;
        return;
      }

      var sizeEl = document.getElementById('ys-reco-size');
      var inseamEl = document.getElementById('ys-reco-inseam');
      var noteEl = document.getElementById('ys-reco-note');
      var titleEl = document.getElementById('ys-reco-title');
      var actionsEl = document.getElementById('ys-reco-actions');
      var supportEl = document.getElementById('ys-reco-support');

      // --- Size state (independent of inseam) ---
      var below = isMateriallyBelow(waist, 'waist') || isMateriallyBelow(hip, 'hip');
      var wi = sizeIndexFor(waist, 'waist');
      var hi = sizeIndexFor(hip, 'hip');
      var above = !below && (wi === null || hi === null);

      var sizeState = 'match'; // match | below | above
      var sizeLabel = '';
      var sizeName = '';
      var between = false;

      if (below) {
        sizeState = 'below';
        sizeLabel = 'UK 8 is our smallest size';
        sizeName = 'UK 8';
      } else if (above) {
        sizeState = 'above';
        sizeLabel = 'No standard size recommendation';
      } else {
        var idx = Math.max(wi, hi);
        sizeName = chart[idx].size;
        sizeLabel = sizeName;
        between = wi !== hi;
      }

      // --- Inseam state (independent of size) ---
      var inseamMatch = recommendInseam(inseam);
      var inseamState = inseamMatch ? 'match' : 'none';
      var inseamLabel = inseamMatch
        ? inseamMatch.label + ' inseam'
        : 'No close inseam match';

      // --- Title ---
      var bothUnavailable = sizeState === 'above' && inseamState === 'none';
      var bothIdeal = sizeState === 'match' && inseamState === 'match';
      if (titleEl) {
        if (bothUnavailable) {
          titleEl.textContent = 'Outside our current standard range';
        } else if (bothIdeal) {
          titleEl.textContent = 'Your recommended fit';
        } else {
          titleEl.textContent = 'Your closest available fit';
        }
      }

      if (sizeEl) {
        sizeEl.textContent = sizeLabel;
        sizeEl.classList.toggle('ys__reco-size--long', sizeState !== 'match');
      }
      if (inseamEl) {
        inseamEl.textContent = inseamLabel;
        inseamEl.classList.toggle('ys__reco-inseam--muted', inseamState === 'none');
      }

      // --- Support copy (size + inseam explained separately) ---
      var supportParts = [];
      if (sizeState === 'match') {
        supportParts.push(
          'Based on your waist and hip measurements, ' +
            sizeName +
            ' is the closest size in our standard range.'
        );
      } else if (sizeState === 'below') {
        supportParts.push(
          'Based on your measurements, UK 8 is the closest size we currently offer, but it may fit more relaxed than intended.'
        );
      } else {
        supportParts.push(
          'We don’t currently have a standard size recommendation for these measurements.'
        );
      }

      if (inseamState === 'match') {
        supportParts.push(
          'Your inseam measurement is closest to ' + inseamMatch.label + '.'
        );
      } else {
        supportParts.push(
          'We don’t currently offer an inseam close to this measurement.'
        );
      }

      if (supportEl) {
        supportEl.innerHTML = supportParts
          .map(function (p) {
            return '<span class="ys__reco-line">' + p + '</span>';
          })
          .join('');
      }

      var notes = [];
      if (between) {
        notes.push(
          'You’re between sizes, so we recommend the larger size for comfort.'
        );
      }
      if (sizeState === 'below') {
        notes.push(
          'Check the product description and Fit Guide before ordering.'
        );
      } else if (!(sizeState === 'above' && inseamState === 'none')) {
        notes.push(
          'Each silhouette fits a little differently, so check the product description before ordering.'
        );
      } else {
        notes.push('View the Fit Guide for measuring guidance before ordering.');
      }

      if (noteEl) noteEl.textContent = notes.join(' ');

      if (actionsEl) actionsEl.hidden = false;
      box.hidden = false;
    }

    function sanity() {
      var w = parseFloat((els.waist && els.waist.value) || '0');
      var h = parseFloat((els.hip && els.hip.value) || '0');
      if (w && h && h < w && status && !status.dataset.locked) {
        status.textContent = 'Heads up: hips are smaller than waist — please double-check.';
      }
    }

    function buildPayload() {
      var payload = {
        unit_system: unit,
        customer_gid: window.__customerGID || null,
        date_taken: new Date().toISOString().slice(0, 10)
      };
      numericFields.forEach(function (k) {
        payload[k] = (els[k] && els[k].value) || null;
      });
      return payload;
    }

    async function saveToCartAttributes(payload) {
      var attributes = {};
      var labels = { waist: 'Waist', hip: 'Hip', inseam: 'Inseam' };
      numericFields.forEach(function (k) {
        if (payload[k]) attributes[labels[k]] = payload[k] + ' ' + payload.unit_system;
      });

      await fetch(
        ((window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/') +
          'cart/update.js',
        {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ attributes: attributes })
        }
      );
    }

    wrap.addEventListener('input', function (e) {
      if (e.target && e.target.matches('input[type="number"]')) {
        var v = e.target.value;
        if (v !== '') e.target.value = toNum(v);
        if (status) delete status.dataset.locked;
        refreshSaveState();
        sanity();
      }
    });

    unitBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var newUnit = btn.getAttribute('data-unit');
        if (newUnit === unit) return;

        var factor = unit === 'cm' && newUnit === 'in' ? 0.3937008 : 2.54;
        numericFields.forEach(function (k) {
          var el = els[k];
          if (!el || el.value === '') return;
          el.value = toNum(parseFloat(el.value) * factor);
        });

        unit = newUnit;
        unitBtns.forEach(function (b) {
          b.classList.toggle('active', b.getAttribute('data-unit') === unit);
        });
        unitLabels.forEach(function (el) {
          el.textContent = unit === 'in' ? 'in' : 'cm';
        });
        if (status) delete status.dataset.locked;
        refreshSaveState();
      });
    });

    saveBtn.addEventListener('click', async function () {
      if (saveBtn.disabled) return;

      saveBtn.disabled = true;
      saveBtn.classList.remove('enabled');
      if (status) {
        status.dataset.locked = '1';
        status.textContent = 'Saving…';
      }

      var payload = buildPayload();

      try {
        var existing = {};
        try {
          existing = JSON.parse(localStorage.getItem(LS_KEY) || '{}') || {};
        } catch (_) {}
        var merged = Object.assign({}, existing, payload);
        localStorage.setItem(LS_KEY, JSON.stringify(merged));
        await saveToCartAttributes(payload);

        if (payload.customer_gid) {
          var r = await fetch(SAVE_URL, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(payload)
          });
          var data = await r.json();
          if (!r.ok || !data.ok) throw new Error(data.error || 'Save failed');
        }

        if (status) {
          status.textContent = payload.customer_gid
            ? 'Saved — My Silhouette is linked to your account.'
            : 'Saved in this browser — create an account to keep them permanently.';
        }
        setTimeout(function () {
          if (status) delete status.dataset.locked;
          refreshSaveState();
        }, 2500);
      } catch (err) {
        console.error(err);
        if (status) {
          status.textContent = 'Saved locally, but account sync had an issue. Please try again.';
          delete status.dataset.locked;
        }
        refreshSaveState();
      }
    });

    refreshSaveState();
  });
})();
